import LinkAccountsStep from './LinkAccountsStep';
import MembersEmails from './member_email/MembersEmails';
import MemberForm from './member_form/MemberForm';
import MembersAddComp from './member_sign_ups/MemberSignUps';
import MemberTypes from './member_types/MemberTypes';

export function getActiveStep(activeStep) {
	switch (activeStep) {
		case 1:
			return LinkAccountsStep;
		case 2:
			return MemberTypes;
		case 3:
			return MemberForm;
		case 4:
			return MembersEmails;
		case 5:
			return MembersAddComp;
		default:
			return LinkAccountsStep;
	}
}
